import { BaseWebhook, WebhookEvent } from "@/types/domain";
import { Label } from "@/components/common/FormLabel";
import { Path, UseFormRegister } from "react-hook-form";
import React from "react";

interface WebhookEventSelectorProps<T extends BaseWebhook> {
  groupedEvents: Record<string, WebhookEvent[]>;
  register: UseFormRegister<T>;
}

export const WebhookEventSelector = <T extends BaseWebhook>({
  groupedEvents,
  register
}: WebhookEventSelectorProps<T>) => (
  <table className="min-w-full">
    <thead className="border-t border-b border-table-border">
      <tr className="bg-table-header">
        <th className="px-4 py-2 text-left font-semibold text-table-header-foreground w-1/12">Subscribed</th>
        <th className="px-4 py-2 text-left font-semibold text-table-header-foreground">Event Name</th>
        <th className="px-4 py-2 text-left font-semibold text-table-header-foreground">Event Description</th>
      </tr>
    </thead>
    <tbody>
      {Object.entries(groupedEvents).map(([category, events]) => (
        <React.Fragment key={category}>
          <tr>
            <td colSpan={3} className="bg-gray-100 px-4 py-2 font-semibold text-md text-gray-700 border-t border-gray-200">
              {category}
            </td>
          </tr>
          {events.map((event: WebhookEvent) => (
            <tr key={event.id} className="border-t border-gray-100">
              <td className="px-4 py-2">
                <input
                  {...register(`eventIds.${event.id}` as Path<T>)}
                  id={`eventIds.${event.id}`}
                  className="size-5 rounded-sm border-gray-300 mr-2"
                  type="checkbox"
                />
              </td>
              <td className="px-4 py-2">
                <Label
                  forField={`eventIds.${event.id}`}
                  label={event.name}
                />
              </td>
              <td className="px-4 py-2">
                {event.description && (
                  <p className="text-gray-600 text-sm mt-1">
                    {event.description}
                  </p>
                )}
              </td>
            </tr>
          ))}
        </React.Fragment>
      ))}
    </tbody>
  </table>
);
